import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { NakedButton, Wrapper } from 'roo-ui/components';
import Markup from 'components/Markup';
import Modal from 'components/Modal';
import { useModal } from 'lib/hooks';
import { useDataLayer } from 'hooks/useDataLayer';

const AboutThisProperty = ({ property, ...rest }) => {
  const { openModal, modalProps } = useModal();
  const { emitInteractionEvent } = useDataLayer();

  const name = property.name || '';
  const description = property.description || '';

  const handleOnClick = useCallback(() => {
    openModal();
    emitInteractionEvent({ type: 'About This Property Pop Up', value: 'Link Selected' });
  }, [emitInteractionEvent, openModal]);

  return (
    <Wrapper {...rest}>
      <NakedButton
        color="ui.link"
        hoverColor="ui.linkHover"
        textDecoration="underline"
        onClick={handleOnClick}
        py={2}
        data-testid="about-this-property-btn"
      >
        About this property
      </NakedButton>
      <Modal {...modalProps} title={`About ${name}`} data-testid="property-description-model">
        <Markup content={description} data-testid="property-description" />
      </Modal>
    </Wrapper>
  );
};

AboutThisProperty.propTypes = {
  property: PropTypes.object,
};

AboutThisProperty.defaultProps = {
  property: {},
};

export default AboutThisProperty;
